<template>
  <div class="card suggestion-edit-header" :class="{ 'suggestion-edit-header--not-approval': !getHasCampaignApproval }">
    <div class="suggestion-edit-header__text">
      <base-card-header :title="title" svg="Pencil"></base-card-header>

      <div class="suggestion-edit-header__status" v-if="getMode === 'edit' && !loadingSuggestionsDetail">
        <strong>{{ $tc('_status', 2) }}: </strong>
        <span :class="statusClass">{{ statusLabel }}</span>
      </div>
    </div>

    <ul class="seh__nav nav nav-tabs nav-justified" v-if="getHasCampaignApproval">
      <li class="seh__item nav-item">
        <a
          class="seh__link nav-link"
          :class="{ active: isActive('composition') }"
          @click.prevent="setActive('composition')"
          >{{ $t('campaigns.action-composition') }}</a
        >
      </li>
      <li v-if="suggestionDetail.isEnabledApproval" class="seh__item nav-item">
        <a
          class="seh__link nav-link"
          :class="{ active: isActive('participants') }"
          @click.prevent="setActive('participants')"
          >{{ $t('campaigns.list-of-participants') }}</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
// libs
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'CampaignsManagementEditHeader',
  computed: {
    ...mapState('campaignsManagement', ['suggestionDetail', 'loadingSuggestionsDetail']),
    ...mapGetters(['getHasCampaignApproval']),
    ...mapGetters('campaignsManagement', ['getActivePage', 'getMode']),
    title() {
      return this.getMode === 'edit' ? this.$t('360.campaigns.details.edit') : this.$t('360.campaigns.details.new');
    },
    statusClass() {
      return this.suggestionDetail.enabled
        ? 'suggestion-edit-header__status--active'
        : 'suggestion-edit-header__status--inactive';
    },
    statusLabel() {
      return this.suggestionDetail.enabled ? this.$t('item-active') : this.$t('item-inactive');
    },
  },
  mounted() {
    this.resetData();
  },
  methods: {
    ...mapActions('campaignsManagement', ['setActivePage', 'resetData']),
    isActive(menuItem) {
      return this.getActivePage === menuItem;
    },
    setActive(menuItem) {
      this.setActivePage(menuItem);
    },
  },
};
</script>

<style lang="scss" scoped>
.suggestion-edit-header {
  position: relative;
  margin-bottom: 20px;
  width: 100%;
  padding: 30px 50px 0;
  box-shadow: 0px 4px 7px 0px #00000012;

  &--not-approval {
    padding-bottom: 20px;
    border-bottom: 1px solid $gray-400;

    &,
    .card {
      margin-bottom: 0 !important;
      border-radius: 8px 8px 0 0;
    }
  }

  &__text {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 15px;
  }

  &__status {
    display: flex;
    align-items: center;

    strong {
      margin-right: 4px;
      color: $gray-800;
      font-weight: 600;
    }

    &--active,
    &--inactive {
      display: inline-flex;
      align-items: center;
      padding: 2px 10px;
      border-radius: 20px;
      font-weight: bold;
      font-size: 12px;
      font-weight: 500;

      &::before {
        content: '';
        display: inline-block;
        width: 6px;
        height: 6px;
        margin-right: 6px;
        border-radius: 50%;
      }
    }

    &--active {
      background-color: #e0ffe9;
      color: #27ae60;

      &::before {
        background-color: #27ae60;
      }
    }

    &--inactive {
      color: $gray-600;
      background: rgba(244, 244, 244, 1);

      &::before {
        background-color: $gray-600;
      }
    }
  }

  .seh__nav {
    width: 40%;
    margin-top: 8px;
    border: none;
  }

  .seh__item {
    justify-content: flex-start;
    flex-grow: initial;
    flex-basis: initial;
    cursor: pointer;

    &:first-child {
      margin-left: -10px;
    }
  }

  .seh__link {
    color: $gray-700;
    border: none;
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;

    &.active {
      color: $oto-omni;
      border-bottom: 3px solid $oto-omni;
    }
  }
}
</style>
